var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{ref:"countUpElement",staticClass:"annual-report-numbers--detail-value u-reset"},[(_vm.shouldCountUp)?_c('VueCountUp',{attrs:{"end-val":_vm.value,"options":_vm.countUpOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }